export default __webpack_public_path__ + "static/media/galleryEmptyState.aca29590.svg";